import { Paper, PaperProps } from "@mui/material"
import React, { useRef } from "react"
import Draggable from "react-draggable"
import "./dialogArrastavel.scss"

/**
 * Paper de Dialog do MUI que pode ser ARRASTADO pela barra de título. Padrão único do projeto —
 * não copiar esta montagem para dentro de componente nenhum.
 *
 * COMO USAR num modal:
 *
 *   <Dialog ... PaperComponent={PaperArrastavel}>
 *       <DialogTitle>...</DialogTitle>          // já vira alça, sem mais nada
 *
 * Se o modal tiver barra de título PRÓPRIA (um <div> em vez do <DialogTitle>), marque esse
 * elemento com o atributo:
 *
 *       <div className={estilos.titulo} data-arrastar-dialog>...</div>
 *
 * O cursor e o `user-select` da barra saem do `dialogArrastavel.scss` (um arquivo só, global).
 *
 * DETALHES QUE NÃO SÃO OPCIONAIS:
 *
 * - Entra por `PaperComponent`, NUNCA por `slots={{ paper }}`. O `slots` SUBSTITUI o styled
 *   `DialogPaper` do MUI e leva junto os estilos dele — `margin: 32`, `display: flex/column`,
 *   `overflowY`, `maxHeight` e o `maxWidth` do breakpoint (600px no `sm` padrão) — o que estica o
 *   modal na horizontal. O `PaperComponent` o MUI aplica como `as` do próprio DialogPaper
 *   (Dialog.js), então o tamanho e o comportamento padrão do Paper são preservados.
 *
 * - `nodeRef` é obrigatório: o React 19 removeu o `ReactDOM.findDOMNode`, e o react-draggable
 *   (>= 4.7) lança erro explícito quando a ref não vem.
 *
 * - `handle` restringe o arrasto à barra de título — o corpo do modal continua clicável e
 *   selecionável normalmente. O react-draggable casa esse seletor subindo do alvo do evento até o
 *   nó arrastado, então o seletor é escopado neste Paper mesmo sendo global.
 *
 * - `cancel` tira do arrasto o que é clicável dentro da barra (o X de fechar, principalmente):
 *   sem isso um clique com micro-movimento no botão vira arrasto e o clique se perde.
 *
 * - `bounds="parent"`: o container do Dialog ocupa a viewport, então o modal não sai da tela.
 */

const SELETOR_ALCA_ARRASTO = ".MuiDialogTitle-root, [data-arrastar-dialog]"

const SELETOR_CANCELAR_ARRASTO = "button, a, input, select, textarea, [role='button'], .MuiIconButton-root"

export const PaperArrastavel = (props: PaperProps) => {
    const referenciaPaper = useRef<HTMLDivElement>(null)

    return <Draggable
        nodeRef={referenciaPaper}
        handle={SELETOR_ALCA_ARRASTO}
        cancel={SELETOR_CANCELAR_ARRASTO}
        bounds="parent"
    >
        <Paper {...props} ref={referenciaPaper} />
    </Draggable>
}
